import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
const B = `${API}/api/jarvis-brain`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return (typeof d === 'string' ? d : d?.message) || e?.response?.data?.error?.message || e?.message || 'Something went wrong';
};

export const jv = {
  insights: (t) => axios.get(`${B}/insights`, h(t)).then((r) => r.data),
  summary: (t) => axios.get(`${B}/summary`, h(t)).then((r) => r.data),
  brief: (t, refresh) => axios.get(`${B}/brief${refresh ? '?refresh=true' : ''}`, h(t)).then((r) => r.data),
  popup: (t) => axios.get(`${B}/popup`, h(t)).then((r) => r.data),
  team: (t) => axios.get(`${B}/team`, h(t)).then((r) => r.data.items),
  dismiss: (t, id) => axios.post(`${B}/insights/${id}/dismiss`, {}, h(t)).then((r) => r.data),
  snooze: (t, id) => axios.post(`${B}/insights/${id}/snooze`, {}, h(t)).then((r) => r.data),
  restore: (t, id) => axios.post(`${B}/insights/${id}/restore`, {}, h(t)).then((r) => r.data),
  approve: (t, id, body) => axios.post(`${B}/insights/${id}/approve`, body, h(t)).then((r) => r.data),
  record: (t, id, body) => axios.post(`${B}/insights/${id}/record`, body, h(t)).then((r) => r.data),
  settings: (t, body) => axios.put(`${B}/settings`, body, h(t)).then((r) => r.data),
  scan: (t) => axios.post(`${B}/scan`, {}, h(t)).then((r) => r.data),
};

// Resends reuse the existing tool endpoints (same permissions, logging and SMS rules as doing it by hand).
export const resend = (t, kind, ref) => {
  if (kind === 'resend_portal') return axios.post(`${API}/api/onboarding/applications/${ref.app_id}/applicants/${ref.applicant_id}/invite-sms`, { base_url: window.location.origin }, h(t));
  if (kind === 'resend_esign') return axios.post(`${API}/api/esign/documents/${ref.doc_id}/signers/${ref.signer_id}/resend`, {}, h(t));
  return axios.post(`${API}/api/id-verify/verifications/${ref.vid}/resend-sms`, {}, h(t));
};

export const SEV = {
  urgent: { label: 'Urgent', dot: 'bg-rose-500', chip: 'bg-rose-50 text-rose-700 ring-rose-200' },
  important: { label: 'Important', dot: 'bg-amber-500', chip: 'bg-amber-50 text-amber-800 ring-amber-200' },
  later: { label: 'Can wait', dot: 'bg-slate-400', chip: 'bg-slate-100 text-slate-700 ring-slate-200' },
};

export const ago = (iso) => {
  if (!iso) return 'never';
  const m = Math.round((Date.now() - new Date(iso)) / 60000);
  return m < 1 ? 'just now' : m < 60 ? `${m}m ago` : m < 1440 ? `${Math.round(m / 60)}h ago` : `${Math.round(m / 1440)}d ago`;
};
